module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1504-fe149afabf3ababd72689d06920240c0.png";